import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useMaterialUIController } from 'context';
import { getColorMappings } from 'components/ColorComponent/ColorComponent';
import { Paper } from '@mui/material';


export default function IconMenu(props) {

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const [controller] = useMaterialUIController();
    const { darkMode, sidenavColor } = controller;
    const { tableBorder } = getColorMappings(sidenavColor);
    return (
        <div>
            <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? 'long-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
            >
                <MoreVertIcon color={darkMode ? 'white' : 'gray'} />
            </IconButton>
            <Menu
                id="long-menu"
                MenuListProps={{
                    'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperComponent={(props) => (
                    <Paper
                        {...props}
                        style={{
                            minWidth: '60px',
                            top: "290px",
                            left: "1316px",
                            border: `1px solid ${tableBorder}`,
                        }}
                    />
                )}
            >
                {props?.row?.props?.children.map((option, index) => {
                    const isDisabled = option.props.children.props.disabled;
                    return (
                        <MenuItem
                            key={index}
                            onClick={isDisabled ? null : handleClose}
                            style={{
                                cursor: isDisabled ? 'not-allowed' : 'pointer',
                                opacity: isDisabled ? 0.5 : 1,

                            }}
                            disabled={isDisabled}
                        >
                            {option}
                        </MenuItem>
                    )
                })}
            </Menu>
        </div>
    );
}


